import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.616 11.426A1 1 0 0 0 14 11.5a1 1 0 0 0 .71-1.71l-2.5-2.5a1 1 0 0 0-1.42 0l-2.5 2.5a1.004 1.004 0 0 0 1.42 1.42l.79-.794V16a1 1 0 0 0 2 0v-5.584l.79.794a1 1 0 0 0 .326.216"
    />
  </svg>
);
export default SvgArrowUpExtraSmall;
